import { render, staticRenderFns } from "./ArcaneSanctuary.vue?vue&type=template&id=483b610c"
import script from "./ArcaneSanctuary.vue?vue&type=script&lang=js"
export * from "./ArcaneSanctuary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports